import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { LoginForm } from './LoginForm';
import { RegisterForm } from './RegisterForm';
import { StyledForm, StyledInput, SubmitButton, ErrorMessage, StyledImage, StyledComment } from './styled';
import { BASE_URL } from '../../environment/environment'
import axios from 'axios';
import logo from '../../images/logo.png'

export const AuthWrapper = () => {
  const [email, setEmail] = useState('');
  const [isRegistering, setIsRegistering] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const checkEmail = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);

    try {
      const response = await axios.get(
        `${BASE_URL}/Auth/check-username?email=${encodeURIComponent(email)}`,
        { headers: { 'Content-Type': 'application/json' } }
      );

      if (response.status === 200) {
        setIsRegistering(response.data.registrationRequired);
        console.log(response.data);
      } else {
        throw new Error('Błąd sprawdzania e-maila');
      }
    } catch (error) {
      console.error(error);
      setError(error.response?.data || "Wystąpił błąd");
      setTimeout(() => {
        navigate('/');
      }, 2000);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      {isRegistering === null ? (
        <StyledForm onSubmit={checkEmail}>
          <StyledImage src={logo} alt="Logo" />
          <StyledComment>Wprowadź e-mail, aby kontynuować</StyledComment>
          <StyledInput
            autoComplete="email" 
            type="email"
            placeholder="Wprowadź e-mail"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            disabled={loading}
          />
          <SubmitButton type="submit" disabled={loading || !email}>
            {loading ? 'Przetwarzanie...' : 'Kontynuuj'}
          </SubmitButton>
          {error && <ErrorMessage>{error}</ErrorMessage>}
        </StyledForm>
      ) : isRegistering ? (
        <RegisterForm email={email} />
      ) : (
        <LoginForm email={email} />
      )}
    </div>
  );
};
